// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kabQ","footer":"styles_footer__3F9aG","passCodeTooltip":"styles_passCodeTooltip__3xA8D"};